import React, { useState, useEffect } from "react";
import { useNavigate, suseLocation } from "react-router-dom";
import { DeleteIcon, MapIcon } from "../../../assets/icons";
import { useAppContext } from "../../Context/AppContext";
import CustomTooltip from "../../CustomTooltip";
import "../Georeferenziazioni.scss";

const headers = [
  { key: "tipo", label: "Layer", width: "20%" },
  { key: "chiave", label: "Identificativo", width: "20%" },
  { key: "valore", label: "Valore", width: "20%" },
  { key: "action", label: "", width: "5%" },
];

const GeoreferenziazioniTable = ({ georeferenziazioni, handleDeleteGeoreferenziazione, edit }) => {
  const navigate = useNavigate();
  const { mapViewTarget, setMapViewTarget } = useAppContext();



  const handleMapView = (e) => {
    const target = { comune: e.comune, layer: e.tipo, key: e.chiave, value: e.valore };
    setMapViewTarget(target);
    navigate("/MapView");
  };



  /* ADD ACTION BUTTON */
  /*
  georeferenziazioni?.forEach((georeferenziazione) => {
    georeferenziazione["action"] = edit ? (
      <CustomTooltip text="Elimina riferimento GIS">
        <button
          className="georeferenziazioni-icons"
          onClick={() => handleDeleteGeoreferenziazione(georeferenziazione)}
        >
          <DeleteIcon fillColor="var(--archeo-color)" />
        </button>
      </CustomTooltip>
    ) : (
      <CustomTooltip text="Visualizza su mappa">
        <button
          className="georeferenziazioni-icons"
          onClick={() => handleMapView(georeferenziazione)}
        >
          <MapIcon fillColor="var(--archeo-color)" />
        </button>
      </CustomTooltip>
    );
  });
  */

  const renderActionCell = (georeferenziazione) => {
    if (edit) {
      return (
        <CustomTooltip text="Elimina riferimento GIS">
          <button
            className="georeferenziazioni-icons"
            onClick={() => handleDeleteGeoreferenziazione(georeferenziazione)}
          >
            <DeleteIcon fillColor="var(--archeo-color)" />
          </button>
        </CustomTooltip>
      );
    }
    return (
      <CustomTooltip text="Visualizza su mappa">
        <button
          className="georeferenziazioni-icons"
          onClick={() => handleMapView(georeferenziazione)}
        >
          <MapIcon fillColor="var(--archeo-color)" />
        </button>
      </CustomTooltip>
    );
  };

  return (
    <>
      <div className="georeferenziazioni-table-container">
        <div className="">
          <header className="georeferenziazioni-table-header">
            {headers?.map((header, index) => (
              <div
                key={index}
                className="georeferenziazioni-header-item"
                style={{
                  maxWidth: `${header.width}`,
                  minWidth: `${header.width}`,
                }}
              >
                <div className="georeferenziazioni-header-item-text">
                  {header.label}
                </div>
              </div>
            ))}
          </header>
          {georeferenziazioni && georeferenziazioni.length > 0 ? (
            georeferenziazioni.map((item, index) => {
              return (
                <div className={`georeferenziazioni-row`} key={index}>
                  {headers?.map((header, headerIndex) => (
                    <div
                      key={index + headerIndex}
                      className={`georeferenziazioni-row-item ${header.className || ""}`}
                      style={{ width: `${header.width}` }}
                    >
                      {header.key === "action" ? renderActionCell(item) : item[header.key]}
                    </div>
                  ))}
                </div>
              );
            })
          ) : (
            <div className="georeferenziazioni-row">
              <div className="georeferenziazioni-row-item" style={{ width: "100%" }}>
                Nessun dato presente
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default GeoreferenziazioniTable;
